import React from 'react';

// Custom icon for the pharma report generation action.
// Based on the FontAwesome "file-word" glyph (document silhouette with a
// folded top-right corner), but with the "W" replaced by a pill/capsule
// symbol, per PO decision (21.08.26): pharma reports use a pill icon
// instead of the Word icon, keeping the same file shape as the base
// "file-word" icon used for the standard (molgen) report.
// Body/notch path data copied verbatim from the actually installed
// @fortawesome/free-solid-svg-icons faFileWord (v6.7.2, sharp corners) so
// it matches the real rendered molgen icon exactly - not the rounded-corner
// FA v7 web glyph.
const PharmaReportIcon = ({
  style,
  className,
}: {
  style?: React.CSSProperties;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    className={className}
    style={{
      height: '1em',
      width: '0.75em',
      display: 'inline-block',
      verticalAlign: '-0.125em',
      overflow: 'visible',
      ...style,
    }}
  >
    {/* Document shape with folded corner, identical to fa-file-word */}
    <path
      fill="currentColor"
      d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0z"
    />
    {/* Pill/capsule symbol in place of the "W": a white capsule with a
    dividing line, drawn on top of the solid document body (rather than
    relying on path-winding "holes" like fa-file-word does for its "W",
    which does not survive splitting the glyph into separate <path>s). */}
    <g transform="rotate(45 192 340)">
      <path
        fill="#ffffff"
        d="M107 272 L277 272 A68 68 0 0 1 277 408 L107 408 A68 68 0 0 1 107 272 Z"
      />
      <path fill="currentColor" d="M186 272 L198 272 L198 408 L186 408 Z" />
    </g>
  </svg>
);

export default PharmaReportIcon;
